import script from "./json-schema.vue?vue&type=script&lang=js"
export * from "./json-schema.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__